(() => {
  if (customElements.get('liene-deal-countdown')) return;

  customElements.define('liene-deal-countdown', class extends HTMLElement {
    connectedCallback() {
      this.stop();
      const input = (this.dataset.deadline || '').trim();
      // Require an explicit offset so every visitor sees the same end instant.
      const match = input.match(/^(\d{4})-(\d{2})-(\d{2})T([01]\d|2[0-3]):([0-5]\d):([0-5]\d)(Z|[+-](?:0\d|1[0-4]):[0-5]\d)$/);
      this.deadline = Date.parse(input);
      const calendarDate = match && new Date(`${match[1]}-${match[2]}-${match[3]}T00:00:00Z`);
      const valid = match && Number.isFinite(this.deadline) && Number.isFinite(calendarDate.getTime()) && calendarDate.toISOString().slice(0, 10) === input.slice(0, 10);
      this.hidden = !valid;
      this.querySelector('.liene-deal__timer').hidden = !valid;
      this.querySelector('.liene-deal__ended').hidden = true;
      if (!valid) return;
      this.onVisibility = () => this.tick();
      document.addEventListener('visibilitychange', this.onVisibility);
      this.tick();
    }

    tick() {
      clearTimeout(this.timeout);
      const seconds = Math.max(0, Math.ceil((this.deadline - Date.now()) / 1000));
      const values = { days: Math.floor(seconds / 86400), hours: Math.floor(seconds / 3600) % 24, minutes: Math.floor(seconds / 60) % 60, seconds: seconds % 60 };
      for (const [unit, value] of Object.entries(values)) {
        this.querySelector(`[data-unit="${unit}"]`).textContent = String(value).padStart(2, '0');
      }
      const ended = seconds === 0;
      this.querySelector('.liene-deal__timer').hidden = ended;
      const message = this.querySelector('.liene-deal__ended');
      const heading = this.querySelector('.liene-deal__countdown-heading');
      if (heading) heading.hidden = ended;
      const showMessage = ended && this.dataset.showExpired !== 'false' && Boolean(message.textContent.trim());
      message.hidden = !showMessage;
      this.hidden = ended && !showMessage;
      if (ended) this.stop();
      else if (!document.hidden) this.timeout = setTimeout(() => this.tick(), 1000);
    }

    stop() {
      clearTimeout(this.timeout);
      if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
    }

    disconnectedCallback() { this.stop(); }
  });
})();


(() => {
  if (customElements.get('liene-deal-layout')) return;
  customElements.define('liene-deal-layout', class extends HTMLElement {
    connectedCallback() {
      this.content = this.querySelector('.liene-deal__content');
      if (!this.content) return;
      this.mobile = window.matchMedia('(max-width: 767px)');
      this.schedule = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.fit());
      };
      this.observer = new ResizeObserver(this.schedule);
      this.observer.observe(this);
      this.observer.observe(this.content);
      this.addEventListener('load', this.schedule, true);
      this.mobile.addEventListener('change', this.schedule);
      this.schedule();
    }

    fit() {
      if (!this.mobile.matches) {
        this.style.removeProperty('--deal-mobile-fit');
        return;
      }
      // offsetHeight ignores transforms, so repeated measurements never compound scaling.
      const naturalHeight = this.content.offsetHeight;
      const top = Number(this.dataset.mobileTop || 6);
      const bottom = Number(this.dataset.mobileBottom || 49);
      // The face boundary follows the original artwork after its black top extension.
      const extra = (Number(this.dataset.mobileExtra) || 0) * (this.clientWidth || 390) / 390;
      const safeBottom = extra + Math.max(0, this.clientHeight - extra) * bottom / 100;
      const available = Math.max(0, safeBottom - this.clientHeight * top / 100);
      if (naturalHeight > 0 && available > 0) {
        this.style.setProperty('--deal-mobile-fit', String(Math.min(1, available / naturalHeight)));
      }
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.observer?.disconnect();
      this.removeEventListener('load', this.schedule, true);
      this.mobile?.removeEventListener('change', this.schedule);
    }
  });
})();
